import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { CartDrawer } from './CartDrawer';
export function ShopLayout() {
  const {
    pathname
  } = useLocation();
  const isHome = pathname === '/';
  return <div className="flex min-h-screen w-full flex-col bg-canvas" data-id="element-252" data-mp="2adgv5yguhzfw">
      <Header data-id="element-253" data-mp="2acxlf51cmhcy" />
      <main className={`flex-1 ${isHome ? '' : 'pt-16 lg:pt-[4.5rem]'}`} data-id="element-254" data-mp="2abcsfjuon6h7">
        <Outlet data-id="element-255" data-mp="1dpavzr2ozz90" />
      </main>
      <Footer data-id="element-256" data-mp="1hp1ivjp3lv89" />
      <CartDrawer data-id="element-257" data-mp="1hos0ah6duqcl" />
    </div>;
}